import { apiFunction } from "../../apiCall/function"

export const getQuestion = async (page, topic, exportData) => {
  let url = `question/${page}?topic_id=${topic}`;
  if (exportData) {
    url = url + "&exportData=true";
  }
  return await apiFunction(url, "get", {}, true, exportData ? "blob" : false)
}